import type { FC } from 'react';

import ShareOnSocials from '@eneco/components/ShareOnSocials/ShareOnSocials';
import type { ShareOnSocialsRendering } from '@sitecore/types/ShareOnSocials';

const SitecoreShareOnSocials: FC<ShareOnSocialsRendering> = ({ fields: { label } }) => (
  <ShareOnSocials label={label?.value} />
);

export { SitecoreShareOnSocials };
export default SitecoreShareOnSocials;
